import "./slots.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Collections ??= {};

AppointmentBooking.SlotSuggester.Collections.ConfirmationModalSlots = class ConfirmationModalSlots extends (
  AppointmentBooking.SlotSuggester.Collections.Slots
) {
  comparator(slot) {
    return -(slot.get("provider").get("rating") || 0);
  }
};
